import Editor from "../../Components/common/Editor";
import trans from "./../../../Languages/Languages";
import { useState, useEffect } from "react";
import { Button, Card, message } from "antd";
import API from "../../../API";
import { usePageContext } from "../../../Context/PageContext";

const KIUStudentForum = () => {
  const [editorHtml, setEditorHtml] = useState("");

  const handleTextEditorChange = (html) => {
    setEditorHtml(html);
  };
  const [loading, setLoading] = useState(true);

  const [pageData, setPageData] = useState(null);
  const [isRenaming, setIsRenaming] = useState(false);
  const [renameValue, setRenameValue] = useState("");
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [contextMenuPos, setContextMenuPos] = useState({ x: 0, y: 0 });
  const { triggerRefresh } = usePageContext();


  ///////////////////////////////////////////////////////////////////////////////////////////////
  ///                             Use Effect
  ////////////////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    setLoading(true);

    const init = async () => {
      await API.get("/admin/forums")
        .then((res) => {
          const { des, page } = res.data;
          setPageData(page);
          setRenameValue(page?.title);
          setEditorHtml(des?.description);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    };

    init();
  }, []);

  // Hide context menu on outside click
  useEffect(() => {
    const handleClickOutside = () => {
      setShowContextMenu(false);
    };

    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  const handleSave = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("description", editorHtml);
    API.post("/admin/forums/description/update", formData)
      .then((res) => {
        setLoading(false);

        message.success("Updated Successfully");
      })
      .catch((err) => {
        setLoading(false);

        message.error("something went wrong");
      });
  };


  const handleRenameSubmit = async () => {
    try {
      await API.put(`/admin/pages/slug/${pageData.slug}`, {
        title: renameValue,
      });
      setPageData((prev) => ({
        ...prev,
        title: renameValue,
      }));
      setIsRenaming(false);
      triggerRefresh(); // 🔁 this triggers sidebar reload
    } catch (err) {
      console.error("Rename failed", err);
      message.error("Rename failed");
    }
  };



  return (
    <div className='pages-container'>
      <Card loading={loading} bordered={false}>
        <div className='content-wrapper'>
          <div className='bg-content-container'>
            {/* Title with rename logic */}
            <div style={{ position: "relative" }}>
              <div
                className="fw-600 mb-2"
                onDoubleClick={() => setIsRenaming(true)}
                onContextMenu={(e) => {
                  e.preventDefault();
                  setContextMenuPos({ x: e.clientX, y: e.clientY });
                  setShowContextMenu(true);
                }}
              >
                {isRenaming ? (
                  <input
                    type="text"
                    value={renameValue}
                    autoFocus
                    onChange={(e) => setRenameValue(e.target.value)}
                    onBlur={handleRenameSubmit}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleRenameSubmit();
                    }}
                    style={{ padding: "2px 6px", fontSize: "14px" }}
                  />
                ) : (
                  pageData?.title || "Loading..."
                )}
              </div>

              {showContextMenu && (
                <ul
                  style={{
                    position: "fixed",
                    top: contextMenuPos.y,
                    left: contextMenuPos.x,
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    borderRadius: 4,
                    listStyle: "none",
                    padding: "5px 10px",
                    margin: 0,
                    zIndex: 1000,
                    cursor: "pointer",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                  onClick={() => {
                    setIsRenaming(true);
                    setShowContextMenu(false);
                  }}
                  onMouseLeave={() => setShowContextMenu(false)}
                >
                  <li>{trans.Rename}</li>
                </ul>
              )}
            </div>
            <Editor
              key='KIUStudentForms'
              editorHtml={editorHtml}
              setEditorHtml={setEditorHtml}
              handleChange={handleTextEditorChange}
            />
          </div>
          {/* save changes */}

          <Button
            onClick={handleSave}
            className='btn-save-changes'
            type='primary'
            htmlType='submit'
          >
            {trans.Save}
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default KIUStudentForum;
